'use client';

import React from 'react';
import Link from 'next/link';

const PublicFooter = () => {
  return (
    <footer className="w-full bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 border-t border-slate-700/50 py-8 px-6 mt-auto">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="flex items-center gap-2">
          <Link href="/product" className="text-lg font-bold text-primary hover:text-primary/80 transition-colors">NextGenTask</Link>
          <span className="text-xs text-slate-400 border-l border-slate-600 pl-2">© 2026 All rights reserved.</span>
        </div>
        
        <div className="flex items-center gap-6 text-sm text-slate-300 font-medium">
          <Link href="/product" className="hover:text-primary transition-colors">Product</Link>
          <Link href="/signup" className="hover:text-primary transition-colors">Pricing</Link>
          <Link href="/login" className="hover:text-primary transition-colors">Login</Link>
          <Link href="/signup" className="hover:text-primary transition-colors">Support</Link>
        </div>

        <div className="text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2">
          <span>Powered by <span className="text-primary/90">Quantum Vertex Solutions</span></span>
          <a
            href="https://www.linkedin.com/company/111226900/admin/page-posts/published/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-[#0077b5] transition-colors ml-1"
            aria-label="LinkedIn"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.8v8.37h2.8v-4.67c0-.25.02-.5.1-.68a1.14 1.14 0 0 1 1-.77c.76 0 1 .52 1 1.29v4.83h2.78M6.5 8.37a1.37 1.37 0 0 0 1.3-1.3A1.3 1.3 0 0 0 6.5 5.8a1.3 1.3 0 0 0-1.3 1.3a1.37 1.37 0 0 0 1.3 1.27m1.4 10.13V10.1h-2.8v8.4h2.8z"/>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
